import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { zArr, zNum, zObj, zOptional } from "./zodWrapper.js";
export const TimeseriesIntervalV2 = zObj({
    gte: ZDate,
    lt: ZDate,
});
export const AggregationConfig = z.object({
    groupBy: z.enum(["minute", "hour"]),
    method: z.enum(["average", "latest", "greatest"]),
});
export const GetTimeseriesDataArgs = zObj({
    interval: TimeseriesIntervalV2,
    sensorIds: zArr(zNum()),
    aggregation: zOptional(AggregationConfig),
});
export const TimeseriesData = zObj({
    sensors: zArr(zObj({
        id: zNum(),
        data: zArr(z.tuple([ZDate, zNum()])),
    })),
});
export const GetTimeseriesDataByOpModeArgs = z.object({
    plantId: z.number(),
    opModeIds: z.array(z.number()),
    sensorIds: z.array(z.number()),
    interval: z.object({
        t1: ZDate,
        t2: ZDate,
    }),
    groupBy: z.enum(["none", "hour", "minute"]),
});
export const TimeseriesDataByOpMode = z.object({
    events: z.array(z.object({
        opModeId: z.number(),
        samples: z.array(z.tuple([ZDate, z.array(z.nullable(z.number()))])),
    })),
});
//# sourceMappingURL=timeseries2.js.map